module.exports = __webpack_public_path__ + "img/header-memoireRingsBestseller@2x.ab35959.jpg";